import React from 'react';

import Checkbox from './Checkbox';
import Input from './Input';
import Select from './Select';

const FakeFormField = ({ field, ...props }) => {
	let extra_props = {...field};
	let Component;

	switch(field.type) {
		case 'dropdown':
		case 'select':
			extra_props.values = field.values.split("\n");
			Component = Select;
			break;

		case 'checkbox':
			Component = Checkbox;
			break;

		case 'input':
		default:
			Component = Input;
			break;
	}
	if(extra_props.title != undefined) delete extra_props.title;
	if(extra_props.type != undefined) delete extra_props.type;

	return (
		<Component is_fake={true} {...extra_props}>{field.title}</Component>
	);
}

export default FakeFormField;